module.exports = __webpack_public_path__ + "img/8.aaa6f49c.png";